<template>
  <app-layout>
    <v-card class="ma-3">
      <v-card-title>
        <h2>Informes</h2>
      </v-card-title>
      <v-card-text>
        <report-table-container />
      </v-card-text>
    </v-card>
  </app-layout>
</template>

<script>
import AppLayout from '@/views/layouts/AppLayout.vue';
import ReportTableContainer from '../components/ReportTableContainer.vue';

export default {
  components: { ReportTableContainer, AppLayout },
  computed: {},
};
</script>

<style></style>
